import React from "react";
import styles from "./style.module.css";
import chargerImage from "./Assets/chargers.webp";
import FooterBox from "../../components/FooterBox";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";


type Home_7Props = {
  background?: string;
};

const Home_7: React.FC<Home_7Props> = ({ background }) => {

    const scrollToTop = () => {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 200);
    };

    return (
        <FooterBox background={background}>
            <div className={styles.heroContainer}>
                <div className={styles.imageContainer}>
                    <img src={chargerImage} alt="Charging Station" className={styles.heroImage} />
                </div>
                
                <div className={styles.heroText}>
                    <h1>Charging Reimagined.<br />BreatheEV.</h1>

                    <div className={styles['button-container']}>
                      <Link target="_blank" to={'https://app.breathe-ev.com/'}>
                          Start Charging
                      </Link>
                      <Link onClick={scrollToTop} to={'/partner-with-us'}>
                          Partner With Us <BsArrowRight />
                      </Link>
                  </div>
                </div>
            </div>
        </FooterBox>
    );
};

export default Home_7;
